/**
 * 入力フィルタリングロジック
 */
export const useInputFilter = () => {
  /**
   * 半角数値のみを許可するフィルタリング
   *
   * @param e イベントオブジェクト
   * @param targetRef 入力値を格納するRef
   * @param maxLength 最大入力長
   */
  const filterNumeric = (e: Event, targetRef: Ref<string | number | undefined>, maxLength: number) => {
    _applyFilter(e, targetRef, maxLength, /[^0-9]/g);
  };

  /**
   * 半角英数字のみを許可するフィルタリング
   *
   * @param e イベントオブジェクト
   * @param targetRef 入力値を格納するRef
   * @param maxLength 最大入力長
   */
  const filterAlphanumeric = (e: Event, targetRef: Ref<string | undefined>, maxLength: number) => {
    _applyFilter(e, targetRef, maxLength, /[^a-zA-Z0-9]/g);
  };

  /**
   * 半角英数字と一部の記号のみを許可するフィルタリング
   *
   * @param e イベントオブジェクト
   * @param targetRef 入力値を格納するRef
   * @param maxLength 最大入力長
   */
  const filterHalfWidthCharacter = (e: Event, targetRef: Ref<string | undefined>, maxLength: number) => {
    _applyFilter(e, targetRef, maxLength, /[^a-zA-Z0-9!@#$%^&*()_+\-=[\]{};:'",.<>?/\\|`~]/g);
  };

  /**
   * 入力フィルタリングの共通ロジック
   *
   * @param e イベントオブジェクト
   * @param targetRef 入力値を格納するRef
   * @param maxLength 最大入力長
   * @param regexp フィルタリングに使用する正規表現（除外する文字を指定）
   */
  const _applyFilter = (e: Event, targetRef: Ref<string | number | undefined>, maxLength: number, regexp: RegExp) => {
    const target = e.target as HTMLInputElement;
    const filteredText = target.value.replace(regexp, '').slice(0, maxLength);
    targetRef.value = filteredText;
  };

  return {
    filterNumeric,
    filterAlphanumeric,
    filterHalfWidthCharacter,
  };
};
